import { CurrentUserResourceType } from '../resources/Auth/currentUserSchema';

export let getUserWillReceiveNotificationForYear = (
  user: Pick<CurrentUserResourceType, 'consentedToNotificationForYears' | 'optedOutCommunication'>,
  year: number,
): boolean => {
  if (user.optedOutCommunication) return false;

  let consentMap = user.consentedToNotificationForYears;
  if (!consentMap) return true;

  if (typeof consentMap[year] === 'boolean') return consentMap[year]!;

  // Fall back to the most recent prior year's consent
  let mostRecentPriorYear = Object.keys(consentMap)
    .map(Number)
    .filter(y => y < year)
    .sort((a, b) => b - a)[0];

  return consentMap[mostRecentPriorYear] !== false;
};
